import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 31853 31853"
    {...props}
  >
    <path
      d="M9818 1091h20944v20945c0 4799-3927 8726-8726 8726H9818c-4800 0-8727-3927-8727-8726V9818c0-4800 3927-8727 8727-8727z"
      style={{
        fill: "none",
        stroke: "#2b2a29",
        strokeWidth: 2181.71,
      }}
      className="stroke1"

    />
  </svg>
)
export default SvgComponent
